import React, { useState } from "react";
import { NewDynamicTab } from "../../../components/Page";
import { ExchangeAnalysisHPPCDefaultDates } from "../../../config/DefaultDates";
import { ExchangeMetrics } from "./PriceAnalysis/PriceAnalysis";
import BuyersAndSellers from "./Tabs/BuyersAndSellers";
import PowerExchangeAnalysis from "./Tabs/PowerExchangeAnalysis";
import Overview from "./Tabs/Overview";
import Realtime from "./Tabs/Realtime";
import TrendAnalysis from "./Tabs/TrendAnalysis";
import { TrendingUp, Zap, BarChart3, Bot } from "lucide-react";

import DerivativeAnalysis from "./Tabs/DerivativeAnalysis";
import VidyutAi from "./Tabs/VidyutAi";

import PowerAnalytics from "../PowerAnalytics/PowerMarket/SimulationIndex";

// Placeholder Components
// const Derivative = () => <div className="p-4">Derivative Component (Coming Soon)</div>; // Replaced by actual component
// const PowerAnalysis = () => <div className="p-4">Power Analysis Component (Coming Soon)</div>; // Replaced by actual component
// const VidyutAi = () => <div className="p-4">Vidyut AI Component (Coming Soon)</div>; // Replaced by actual component

const ModuleSwitcher = ({ activeModule, onModuleChange }: { activeModule: string, onModuleChange: (module: string) => void }) => {
  const modules = [
    // { key: "Derivative", label: "Derivative", icon: TrendingUp }, // Moved to Power Analysis
    // { key: "Power Analysis", label: "Power Analysis", icon: Zap },
    { key: "Exchange Analytics", label: "Exchange Analytics", icon: BarChart3 },
    { key: "Vidyut AI", label: "Vidyut AI", icon: Bot },
  ];

  return (
    <div className="flex flex-row gap-x-4 items-center">
      {modules.map(({ key, label, icon: Icon }) => (
        <div
          key={key}
          className={`cursor-pointer transition-colors duration-200 flex items-center gap-2 ${activeModule === key ? "text-[#f1935c]" : "text-gray-400 hover:text-[#34656d]"}`}
          onClick={() => onModuleChange(key)}
          title={label}
        >
          <Icon size={24} strokeWidth={activeModule === key ? 2.5 : 2} />
        </div>
      ))}
    </div>
  );
};

const NewExchange = () => {
  const [activeModule, setActiveModule] = useState(() => {
    const url = new URL(window.location.href);
    const mod = url.searchParams.get("module");
    const validModules = ["Power Analysis", "Exchange Analytics", "Vidyut AI"];
    return mod && validModules.includes(mod) ? mod : "Exchange Analytics";
  });

  const moduleConfig: Record<string, { header: string, tabs: Record<string, React.ReactNode>, trendTabs?: string[], hideDateFilterOnTabs?: string[] }> = {
    "Power Analysis": {
      header: "Power Analysis",
      tabs: {
        "Power Market": <PowerAnalytics />,
        "Derivative": <DerivativeAnalysis />
      },
      trendTabs: ["Derivative", "Power Market"],
      // hideDateFilterOnTabs: [] // Dates enabled for both
    },
    "Exchange Analytics": {
      header: "Exchange Analytics",
      tabs: {
        Collective: <Overview />,
        "Trend Analysis": <TrendAnalysis />,
        Realtime: <Realtime />,
        "Buyers & Sellers": <BuyersAndSellers />,
        "Entity Analysis": <PowerExchangeAnalysis />,
        "Snapshot": <ExchangeMetrics />,
      },
      trendTabs: ["Trend Analysis"],
      hideDateFilterOnTabs: ["Snapshot"]
    },
    "Vidyut AI": {
      header: "Vidyut AI",
      tabs: { "Vidyut AI": <VidyutAi /> },
      hideDateFilterOnTabs: ["Vidyut AI"]
    }
  };

  const handleModuleChange = (module: string) => {
    setActiveModule(module);
    // Clear the 'tab' query parameter to let the new module's default tab take over
    const url = new URL(window.location.href);
    url.searchParams.set("module", module);
    url.searchParams.delete("tab");
    window.history.pushState({}, "", url);
  };

  const currentConfig = moduleConfig[activeModule];

  return (
    <>
      <NewDynamicTab
        headerHeight="h-[68px]"
        defaultDates={ExchangeAnalysisHPPCDefaultDates}
        headerPrefixComponent={<ModuleSwitcher activeModule={activeModule} onModuleChange={handleModuleChange} />}
        header={currentConfig.header}
        hideDateFilterOnTabs={currentConfig.hideDateFilterOnTabs}
        trendTabs={currentConfig.trendTabs}
        tabs={currentConfig.tabs}
      // Force re-render of tabs structure when module changes if needed, but Key on NewDynamicTab might not be necessary if tabs prop updates correctly.
      // However, NewDynamicTab uses useEffect to dispatch tabs. Switching modules changes 'tabs' prop.
      />
    </>
  );
};

export default NewExchange;
